module.exports = __webpack_public_path__ + "static/media/earth.8cd50edf.gif";